import axios from 'axios';
import { cookies } from 'static';
import { authBaseUrl } from './auth';
import { CropsAccountSelection, CropsCompany } from 'types';

const getToken = () => {
  const stored = localStorage.getItem(cookies.FarmersPlanToken);
  return stored ? JSON.parse(stored)?.token : undefined;
};

const getAuthRequestHeaders = () => {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const assertOkResponse = <T,>(payload: T | null | undefined, errors: unknown) => {
  if (payload === null || payload === undefined) {
    throw new Error(typeof errors === 'string' ? errors : 'API Error');
  }

  return payload;
};

export const getUserCompanies = async (): Promise<CropsCompany[]> => {
  const response = await axios.get(`${authBaseUrl()}/auth/me/companies/user-list`, {
    headers: getAuthRequestHeaders(),
    timeout: 10000,
  });

  const payload = response.data?.payload ?? response.data;
  return assertOkResponse(payload, response.data?.errors) || [];
};

export const setActiveCompany = async (
  accountId: number,
): Promise<CropsAccountSelection> => {
  const response = await axios.post(
    `${authBaseUrl()}/auth/me/companies/set-active`,
    { accountId },
    {
      headers: getAuthRequestHeaders(),
      timeout: 10000,
    },
  );

  const payload = response.data?.payload ?? response.data;
  return assertOkResponse(payload, response.data?.errors);
};
